/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f6jr5hl{align-items:flex-start;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.fni485r{flex-wrap:wrap;}
.f1ewtqcl{box-sizing:border-box;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fnllxr2{padding-block:var(--spacingVerticalM);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1o0qvyv{border-radius:var(--borderRadiusLarge);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.foi3q75{border-block-start-color:var(--colorNeutralStroke2);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f1p2dij1{border-block-end-style:solid;}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fwyddsq{border-inline-start-style:solid;}
.f1ftuoky{border-inline-start-color:var(--colorNeutralStroke2);}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.fwl1lcr{border-inline-end-style:solid;}
.f1crbv9w{border-inline-end-color:var(--colorNeutralStroke2);}
.fo0u7mh{border-block-start-color:var(--colorBrandStroke1);}
.fh32zs{border-block-end-color:var(--colorBrandStroke1);}
.fyvlgxw{border-inline-start-color:var(--colorBrandStroke1);}
.f9srtw2{border-inline-end-color:var(--colorBrandStroke1);}
.fi64zpg{flex-shrink:0;}
.f122n59{align-items:center;}
.f4d9j23{justify-content:center;}
.ftrql5j{inline-size:40px;}
.fwyv573{block-size:40px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f16muhyy{color:var(--colorBrandForeground1);}
.f16xkysk{background-color:var(--colorBrandBackground2);}
.fqerorx{flex-grow:1;}
.f1name99{flex-basis:220px;}
.fuzgk9b{min-inline-size:0;}
.f1vx9l62{flex-direction:column;}
.f1j0q4x9{row-gap:var(--spacingVerticalXXS);}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkhj508{font-size:var(--fontSizeBase300);}
.f1i3iumi{line-height:var(--lineHeightBase300);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.fjksvth{overflow-wrap:anywhere;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fy9rknc{font-size:var(--fontSizeBase200);}
.fwrc4pm{line-height:var(--lineHeightBase200);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.f1vfkb3d{unicode-bidi:isolate;}
.f1r2v9sp{direction:ltr;}
.f1va4sj6{direction:rtl;}
.ftuwxu6{display:inline-flex;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1vjz9w0{padding-block:2px;}
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
.f44lkw9{border-radius:var(--borderRadiusCircular);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1nxen24{border-block-start-color:var(--colorNeutralStroke1);}
.f1uccd92{border-block-end-color:var(--colorNeutralStroke1);}
.f32ghg3{border-inline-start-color:var(--colorNeutralStroke1);}
.f129z43g{border-inline-end-color:var(--colorNeutralStroke1);}
.fyind8e{color:var(--colorBrandForegroundLink);}
.f1iuv45f{text-decoration-line:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f47sw1k{padding-block:var(--spacingVerticalXS);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1hcrxcs{color:var(--colorPaletteRedForeground1);}
/** @griffel:css-end **/
/** @griffel:css-start [h] null **/
.f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}
/** @griffel:css-end **/
/** @griffel:css-start [i] null **/
.f1u5sdlw:focus-visible{outline-width:var(--strokeWidthThick);}
.f1u8i3ug:focus-visible{outline-style:solid;}
.fvi4nxw:focus-visible{outline-color:var(--colorStrokeFocus2);}
/** @griffel:css-end **/